import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from '@/common/types/errorResponse';
import { AxiosResponse } from 'axios';

interface UseUnblockClientCardProps {
  cardId?: string;
  onSuccess?: (reponse: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useUnblockClientCard = ({ cardId, onSuccess, onError }: UseUnblockClientCardProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation<AxiosResponse, ErrorResponse>({
    mutationKey: ['unblockClientCard', cardId],
    mutationFn: () => privateAxios.put(`/client/cards/${cardId}/unblock`),
    onSuccess,
    onError,
  });
};

export default useUnblockClientCard;
